define(['exports', 'react', './SexyGaugeCanvas', './styles/CandidateReportsView.css'], function (exports, _react, _SexyGaugeCanvas) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _SexyGaugeCanvas2 = _interopRequireDefault(_SexyGaugeCanvas);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var SexyGauge = function (_Component) {
		_inherits(SexyGauge, _Component);

		function SexyGauge(props) {
			_classCallCheck(this, SexyGauge);

			var _this = _possibleConstructorReturn(this, (SexyGauge.__proto__ || Object.getPrototypeOf(SexyGauge)).call(this, props));

			_this.state = {
				levels: [],
				currentValue: 0,
				labels: []
			};
			_this.currentValueIncrementer = null;
			return _this;
		}

		_createClass(SexyGauge, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				var _props = this.props,
				    _props$levels = _props.levels,
				    levels = _props$levels === undefined ? [] : _props$levels,
				    colors = _props.colors;


				var _levels = [],
				    _labels = [];

				var labelsTotal = 0;
				var totalValue = 0;

				levels.forEach(function (level) {
					return totalValue += level.value;
				});

				levels.forEach(function (level, index) {
					var val = level.value;

					_levels = _levels.concat({
						strokeStyle: colors[level.name],
						min: index === 0 ? 0 : labelsTotal,
						max: labelsTotal + val
					});

					labelsTotal += val;

					// _labels = _labels.concat(val);
					_labels = _labels.concat(labelsTotal);
				});

				this.setState({ levels: _levels, labels: _labels, totalValue: totalValue });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;

				this.currentValueIncrementer = setInterval(function () {

					_this2.increaseCurrentValue(_this2.props.currentValue);
				}, 10);
			}
		}, {
			key: 'increaseCurrentValue',
			value: function increaseCurrentValue(currentValue) {
				if (currentValue > this.state.currentValue) {
					this.setState({ currentValue: this.state.currentValue + 0.1 });
				} else {
					clearInterval(this.currentValueIncrementer);
					this.currentValueIncrementer = null;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    levels = _props2.levels,
				    currentValue = _props2.currentValue,
				    peerValue = _props2.peerValue,
				    totalValue = _props2.totalValue,
				    colors = _props2.colors,
				    icon = _props2.icon,
				    iconContainerClassName = _props2.iconContainerClassName,
				    canvasId = _props2.canvasId,
				    iconStyle = _props2.iconStyle;


				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_SexyGaugeCanvas2.default, {
						key: canvasId + ' ' + iconContainerClassName,
						canvasId: canvasId,
						currentValue: this.state.currentValue,
						labels: this.state.labels,
						staticZones: this.state.levels,
						totalValue: this.state.totalValue }),
					_react2.default.createElement(
						'div',
						{ className: 'relative', style: iconStyle },
						icon
					)
				);
			}
		}]);

		return SexyGauge;
	}(_react.Component);

	exports.default = SexyGauge;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/SexyGauge.js
// module id = 1185
// module chunks = 0